import "./MediaCentre.module.css";
import FraternalExcellenceHeader from "@/reusable_sections/Header";
import LatestNewsCirculars from "./sections/LatestNewsCirculars";
import PartnerWithUs from "./sections/PartnerWithUs";
import InformativeFooter from "@/reusable_sections/Footer";
export default function MediaCentrePage() {
  return <div>
      <FraternalExcellenceHeader />
      <LatestNewsCirculars />
      <PartnerWithUs />
      <InformativeFooter />
    </div>;
}